import type {
  ArticleBlock as ArticleBlockType,
  LeadArticle,
  TeaserArticle,
} from "@/fixtures/shared/category-finance-list/fixtures";

const longExcerpt =
  "中國外交部表示，外交部副部長苗得雨前往伊朗駐華使館弔唁，代表中方對伊朗最高領袖哈梅內伊遇難表示沉痛哀悼。哈梅內伊的兒子穆傑塔巴目前被視為接替哈梅內伊的熱門人選，惟尚未獲得最高權力委員會正式提名，未來局勢仍存在不確定性。";

const oilExcerpt =
  "波斯灣局勢急速升溫，國際油價隔晚再度抽升，紐約期油盤中一度觸及每桶84美元高位，分析估計如荷姆茲海峽航道受阻，全球供應將即時收緊，油價有機會挑戰百元關。";

const marketExcerpt =
  "中東地緣風險急升，避險情緒推動金價及美元同步走強，外資減持新興市場資產，亞太股市普遍偏軟。分析指中東衝突若擴散，將令環球央行的減息決策更為審慎。";

export const IRAN_WAR_HERO: LeadArticle = {
  image: "/images/topics/iran-war/hero-trump.png",
  category: "國際 |",
  title: " 特朗普警戒未息　促伊朗即時停火",
  excerpt:
    "美國總統特朗普聲言對伊朗的最後通牒並非空談，警告若德黑蘭不願在限期內停火，美國海空力量將進一步介入波斯灣。白宮發言人補充，特朗普與內塔尼亞胡通話後，雙方同意維持現有制裁，並研究進一步切斷伊朗能源出口的措施，外界憂慮中東衝突將進一步外溢，影響全球油市與航運。",
  author: {
    name: "高天佑",
    avatar: "/images/authors/高天佑.png",
  },
  time: "3分鐘前",
};

export const IRAN_WAR_HERO_TEASERS: TeaserArticle[] = [
  { title: "中國外交部副部長苗得雨弔唁哈梅內伊", time: "8分鐘前" },
  { title: "油價再衝84美元　市場關注荷姆茲海峽", time: "25分鐘前" },
];

export const IRAN_WAR_ARTICLE_BLOCKS: ArticleBlockType[] = [
  {
    label: "中東局勢",
    layout: "lead-plus-text",
    lead: {
      category: "要聞",
      title: "中東局勢丨中國外交部副部長苗得雨\n弔唁伊朗最高領袖哈梅內伊",
      excerpt: longExcerpt,
      time: "1小時前",
      image: "/images/topics/iran-war/khamenei.png",
    },
    followUp: {
      category: "EJ Global",
      title: "傳中國與伊朗歧離　惟拒絕封鎖荷姆茲海峽",
      excerpt:
        "外電引述消息報道，北京對德黑蘭可能封鎖荷姆茲海峽強烈保留，認為此舉將令國際社會壓力轉向中國，並損害一帶一路在波斯灣的長期布局。中方更傾向以外交手段平衡各方利益。",
      time: "1小時前",
    },
    secondary: [
      {
        category: "時事評論",
        column: "新聞點評",
        author: {
          name: "高天佑",
          avatar: "/images/authors/高天佑.png",
        },
        title: "伊朗進口能源持續輸往中東　波斯灣原油新格局",
        excerpt:
          "雖然美方制裁加碼，但伊朗仍透過第三方船隊將原油輸往多個亞洲買家。能源研究機構指出，新加坡及荷姆茲附近過駁活動明顯增加，波斯灣原油流向出現結構性轉變。",
        time: "3小時前",
        commentCount: 12,
      },
      {
        category: "EJ Global",
        title: "油價上漲丨特朗普警戒不下停　伊朗行動更受關注",
        excerpt:
          "紐約期油重越每桶80美元水平，市場關注美方下一步行動。能源分析師指出，若伊朗加強封鎖姿態，油價短期有機會挑戰95美元，全球通脹風險再度升溫。",
        time: "4小時前",
        commentCount: 8,
        moreImage: "/images/topics/iran-war/hormuz-map.png",
      },
    ],
  },
  {
    label: "市場反應",
    layout: "two-columns",
    lead: {
      category: "要聞",
      title: "中東風險急升　亞太股匯齊現避險潮",
      excerpt: marketExcerpt,
      time: "1小時前",
      image: "/images/topics/iran-war/bull-statue.png",
    },
    followUp: {
      category: "時事評論",
      column: "兩岸論壇",
      author: {
        name: "丁學良",
        avatar: "/images/authors/丁學良.png",
      },
      title: "黃金重越3,400美元　資金加速流向避險資產",
      excerpt:
        "現貨金價隔晚一度觸及每盎斯3,418美元，創近三個月新高。瑞銀指出，地緣風險疊加美國減息預期，黃金本季有望挑戰3,500美元歷史高位。",
      time: "1小時前",
      image: "/images/topics/iran-war/stock-chart.png",
    },
    secondary: [
      {
        category: "EJ Global",
        title: "油組明日特別會議　研究是否進一步減產",
        excerpt:
          "石油輸出國組織及盟友（OPEC＋）將於明日召開特別會議，市場普遍預期沙地與俄羅斯將商討進一步減產配額，以對沖中東衝突可能引發的需求下行風險。",
        time: "3小時前",
        commentCount: 20,
      },
      {
        category: "副刊文化",
        column: "忽然文化",
        author: {
          name: "占飛",
          avatar: "/images/category-finance-list/author1.png",
        },
        title: "中東基金錄連續四周淨流出　避險情緒持續升溫",
        excerpt:
          "EPFR數據顯示，過去四周中東相關基金合共錄得約12億美元淨流出，創2024年初以來最長走資紀錄。資金流向防衛性高息股及黃金ETF。",
        time: "4小時前",
        commentCount: 15,
        moreImage: "/images/topics/iran-war/deloitte-panel.png",
      },
    ],
  },
  {
    label: "外交動向",
    layout: "lead-plus-text",
    lead: {
      category: "EJ Global",
      title: "歐盟召開緊急峰會　研究新一輪對伊朗制裁",
      excerpt:
        "歐盟27國領袖將於本周末召開緊急峰會，討論對伊朗實施新一輪制裁，包括擴大能源禁運及凍結相關金融機構資產。德國總理表態支持加碼制裁，但匈牙利及斯洛伐克對能源禁運仍有保留。",
      time: "1小時前",
      image: "/images/topics/iran-war/eu-summit.png",
    },
    followUp: {
      category: "要聞",
      title: "聯合國呼籲各方克制　秘書長促即時停火",
      excerpt:
        "聯合國秘書長古特雷斯發表聲明，敦促各方立即停火，並警告若中東衝突進一步外溢，將釀成繼俄烏戰爭以來最嚴重的人道危機。安理會將於今晚召開緊急閉門會議。",
      time: "1小時前",
    },
    secondary: [
      {
        category: "時事評論",
        column: "政策論壇",
        author: {
          name: "徐立言",
          avatar: "/images/category-finance-list/author3.png",
        },
        title: "美連戰速波　飾力人工智慧能",
        excerpt:
          "白宮表示，美方將動用人工智能技術協助情報分析，提升對中東戰場態勢的即時掌握。國防部官員透露，五角大樓已批准向中央司令部增派AI輔助平台。",
        time: "3小時前",
        commentCount: 9,
      },
      {
        category: "EJ Global",
        title: "土耳其表態願擔任調停角色　穿梭德黑蘭與華府",
        excerpt:
          "土耳其總統埃爾多安表示，安卡拉願擔任伊朗與美國之間的調停角色，並已分別與德黑蘭及華府高層保持密切聯繫。土方強調，中東不能再承受新一輪戰爭。",
        time: "4小時前",
        commentCount: 11,
        moreImage: "/images/topics/iran-war/trump-speaking.png",
      },
    ],
  },
  {
    label: "能源衝擊",
    layout: "two-columns",
    lead: {
      category: "要聞",
      title: "油組︰若荷姆茲航道受阻　全球油價有機會挑戰每桶100美元",
      excerpt: oilExcerpt,
      time: "1小時前",
      image: "/images/topics/iran-war/gas-pipeline.png",
    },
    followUp: {
      category: "副刊文化",
      column: "政經短評",
      author: {
        name: "占飛",
        avatar: "/images/category-finance-list/author1.png",
      },
      title: "中海油與三大內地煉廠加快戰略儲備　應對潛在斷供風險",
      excerpt:
        "受中東局勢拖累，中海油聯同中石化及中石油已啟動應變方案，加快採購中東以外原油，並提升戰略儲備至90日水平。內地能源主管部門亦研究釋出部分儲備平抑油價。",
      time: "1小時前",
      image: "/images/topics/iran-war/satellite-strike.png",
      commentCount: 0,
    },
    secondary: [
      {
        category: "EJ Global",
        title: "歐洲天然氣價急升15%　寒冬陰霾再現",
        excerpt:
          "受中東局勢及挪威供氣中斷影響，TTF基準天然氣期貨單日急升15%，創近半年最大升幅。德國工業界擔憂高氣價將拖累製造業復甦。",
        time: "3小時前",
        commentCount: 18,
      },
      {
        category: "時事評論",
        column: "市場縱橫",
        author: {
          name: "高天佑",
          avatar: "/images/authors/高天佑.png",
        },
        title: "航運股全線受壓　馬士基料運價短期飆升",
        excerpt:
          "市場擔憂荷姆茲及紅海航線安全，亞太航運股全線下挫。馬士基行政總裁警告，若航線封鎖延續，亞歐運價短期有機會再升三成，全球供應鏈將受波及。",
        time: "4小時前",
        commentCount: 14,
        moreImage: "/images/topics/iran-war/hkma-building.png",
      },
    ],
  },
];

/**
 * A tag bundle — the data behind one `/tags/[slug]` page (header label/title +
 * lead hero + teasers + the stacked article blocks). 伊朗戰爭 is just one tag;
 * add another by registering its own entry here.
 */
export type TagData = {
  slug: string;
  /** Eyebrow above the title, e.g. 主題. */
  label: string;
  title: string;
  hero: LeadArticle;
  teasers: TeaserArticle[];
  articleBlocks: ArticleBlockType[];
};

export const TAGS: Record<string, TagData> = {
  "iran-war": {
    slug: "iran-war",
    label: "主題",
    title: "伊朗戰爭",
    hero: IRAN_WAR_HERO,
    teasers: IRAN_WAR_HERO_TEASERS,
    articleBlocks: IRAN_WAR_ARTICLE_BLOCKS,
  },
};

/** Known tag slugs — drives `generateStaticParams` for `/tags/[slug]`. */
export const TAG_SLUGS = Object.keys(TAGS);

/** Chinese label → authored slug, so `tagRoute("伊朗戰爭")` finds `iran-war`. */
const SLUG_BY_TITLE: Record<string, string> = Object.fromEntries(
  Object.values(TAGS).map((t) => [t.title, t.slug])
);

export function slugForTagTitle(title: string): string | undefined {
  return SLUG_BY_TITLE[title.trim()];
}

/**
 * Resolve a tag page.
 *
 * Only `iran-war` is authored, but tags are linked from all over the product —
 * the article-detail topic chips, 追蹤相關主題, and the 主題 tab of
 * `/account/following`. Every one of those was landing on a 404, because
 * `tagRoute()` builds `/tags/<label>` from a Chinese label that is not a key
 * here.
 *
 * So an unauthored tag renders the same page shell under its own name rather
 * than 404ing. The article blocks are the shared fixture set, as they are on
 * every other listing page in this build — this is placeholder content, not a
 * claim that these articles carry that tag. Drop the fallback once tags come
 * from a real API.
 */
export function getTag(slug: string): TagData | undefined {
  const known = TAGS[slug];
  if (known) return known;

  const title = safeDecode(slug).trim();
  if (!title) return undefined;

  const base = TAGS[TAG_SLUGS[0]];
  return { ...base, slug, title };
}

function safeDecode(value: string): string {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}
